/**
 * Generates a unique request ID for tracing API requests.
 * Uses native crypto.randomUUID() for UUIDv4 generation.
 *
 * @returns A UUIDv4 string (e.g., "550e8400-e29b-41d4-a716-446655440000")
 */
export function generateRequestId(): string {
  return crypto.randomUUID();
}
